import * as storeTypes from './template.store-types';
import axios from 'axios';
import { Template } from './models/template.model';

export default {
    namespaced: true,
    state: {
        templates: []
    },
    mutations: {
        [storeTypes.SET_TEMPLATES]: (state, templates) =>
            (state.templates = templates)
    },
    actions: {
        async [storeTypes.ACTION_GET_TEMPLATES](store) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const { 
                            data: {success, error, templates} 
                        } = await axios.get('/api/templates');
                        if (!success) {
                            return reject(error)
                        }
                        store.commit(
                            storeTypes.SET_TEMPLATES,
                            templates.map(template => Template.fromArray(template))
                        )
                        resolve();
                    } catch (error) {
                        reject(error);
                    } finally {
                        // pass;
                    }
                })();
            })
        },
        async [storeTypes.ACTION_CREATE_TEMPLATE](store, { templateName = '', templateSubject = '', templateContent = '' }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const { 
                            data: {success, error} 
                        } = await axios.post('/api/templates', { templateName, templateSubject, templateContent });

                        if (!success) {
                            return reject(error)
                        }
                        store.dispatch(storeTypes.ACTION_GET_TEMPLATES)
                        resolve();
                    } catch ({
                        response: {
                            data: {error}
                        }
                        
                    }) {
                        reject(error);
                    } finally {
                        // pass;
                    }
                })();
            })
        }
    },
    getters: {
        [storeTypes.GET_TEMPLATES]:
            state => state.templates
    }
}